import { Component, Input } from '@angular/core';
import { DependantDto, MemberDto, MemberSearchResultListDto, MembershipDto, TicketModeEnum, WorkflowDto } from '../../../../../service/dto';
import { environment } from '../../../../../../environments/environment';
import { Router } from '@angular/router';


class WrapperMemberSearchResultDto {
	payload!: MemberDto;
	dependents!: DependantDto[];
	memberships!: WrapperMemberSearchResultMembershipDto[];
	expanded!: boolean;
	checked = false;
	indeterminate = false;
	setOfCheckedId = new Set<number>();
}
class WrapperMemberSearchResultMembershipDto {
	payload!: MembershipDto;
	selected!: boolean;
}

@Component({
	selector: 'app-ticket-member-search-by-member',
	standalone: false,
	templateUrl: './ticket-member-search-by-member.component.html',
	styleUrl: './ticket-member-search-by-member.component.scss'
})
export class TicketMemberSearchByMemberComponent {
	@Input() loading!: boolean;
	@Input() ticketMode!: TicketModeEnum;
	@Input() workflows: WorkflowDto[] = [];
	_data?: WrapperMemberSearchResultDto[];
	workflow?: WorkflowDto;

	constructor(private router: Router) {

	}

	@Input()
	set data(input: MemberSearchResultListDto | undefined) {
		if(input == undefined){
			this._data=undefined;
			return;
		}
		this._data = input.results.map(item => {
			return {
				payload: item.member,
				dependents: item.member.dependants,
				memberships: item.member.memberships.map(i => { return { payload: i, selected: false } }),
				checked: false,
				indeterminate: false,
				setOfCheckedId: new Set<number>(),
				expanded: true
			};
		});
	}


	get memberTicketRequiredCategory(): boolean {
		return environment.createMemberTicketWithoutCategory;
	}

	canCreateMemberTicket(input: WrapperMemberSearchResultDto): boolean {
		if (!this.workflow) {
			return false;
		}
		if (this.memberTicketRequiredCategory == true) {
			return input.setOfCheckedId.size > 0;
		}
		return true;
	}
	canCreateDependantTicket(input: WrapperMemberSearchResultDto): boolean {
		if (!this.workflow) {
			return false;
		}
		return true;
	}
	startTicketForMember(input: WrapperMemberSearchResultDto) {
		if (input.setOfCheckedId.size == 0) {
			this.router.navigate(['/ticket', this.workflow!.ticketMode, this.workflow!.id, 'member', input.payload.id]);
		} else {
			const categories = Array.from(input.setOfCheckedId).join(',');
			this.router.navigate(['/ticket', this.workflow!.ticketMode, this.workflow!.id, 'member', input.payload.id, categories]);
		}
	}
	startTicketForDependant(input: DependantDto) {
		this.router.navigate(['/ticket', this.workflow!.ticketMode, this.workflow!.id, 'dependent', input.id]);
	}
	onAllChecked(member: WrapperMemberSearchResultDto, selected: boolean) {
		member.memberships.forEach(item => this.updateCheckedSet(member, item, selected));
		this.refreshCheckedStatus(member);
	}
	onItemChecked(member: WrapperMemberSearchResultDto, membership: WrapperMemberSearchResultMembershipDto, checked: boolean): void {
		this.updateCheckedSet(member, membership, checked);
		this.refreshCheckedStatus(member);
	}
	updateCheckedSet(member: WrapperMemberSearchResultDto, membership: WrapperMemberSearchResultMembershipDto, checked: boolean): void {
		if (checked) {
			member.setOfCheckedId.add(membership.payload.id);
		} else {
			member.setOfCheckedId.delete(membership.payload.id);
		}
	}
	refreshCheckedStatus(member: WrapperMemberSearchResultDto): void {
		member.checked = member.memberships.every(item => member.setOfCheckedId.has(item.payload.id));
		member.indeterminate = member.memberships.some(item => member.setOfCheckedId.has(item.payload.id)) && !member.checked;
	}
}
